import { PaymentTypeEnum } from '../../enums';
import { Option } from '../../type';

export const LICENSE_TYPE_OPTIONS: Option<PaymentTypeEnum>[] = [{ label: 'Full', value: PaymentTypeEnum.Full }];
